import { render, staticRenderFns } from "./iplimit.vue?vue&type=template&id=9297e1da&scoped=true&"
import script from "./iplimit.vue?vue&type=script&lang=js&"
export * from "./iplimit.vue?vue&type=script&lang=js&"
import style0 from "./iplimit.vue?vue&type=style&index=0&id=9297e1da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9297e1da",
  null
  
)

export default component.exports